import { base64ToArrayBuffer, stringFormatingToPascal } from "js/formatting";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { getImage } from "redux/slices/getImageSlice";
import { useTranslation } from "react-i18next";
import {
  EverlakeLoadingOverlayStyle,
  EverlakeLoadingSpinner,
} from "components/General/EverlakeLoading";

import moment from "moment";
import PDFDialog from "components/ModalDialogs/PDFDialog";
import * as fileSaver from "file-saver";
import LoadingOverlay from "react-loading-overlay";

const ReportCard = ({ data }) => {
  let dispatch = useDispatch();
  const { t } = useTranslation();
  const [pdfSource, setPdfSource] = useState("");
  const [desc, setDesc] = useState("");
  const [pdfDialogState, setPdfDialogState] = useState(false);
  const [name, setName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  return (
    <>
      <LoadingOverlay
        active={isLoading}
        spinner={
          <EverlakeLoadingSpinner
            loadingText={t("AgentReportCard-loadingText")}
            spinnerSize="xs"
            loadingTextMargin="2"
          />
        }
        styles={EverlakeLoadingOverlayStyle}
      >
        {data.map((item, idx) => (
          <div
            key={`row-${idx}`}
            className="p-4 border-b border-theme-rule-medium-light xl:py-6 last:border-b-0"
          >
            <div className="text-xxs text-theme-text-tertiary">
              {moment(item?.document?.dateOfDocument).format("MMMM")}
            </div>
            <div className="grid gap-4 grid-cols-1 sm:grid-cols-[1fr,max-content]">
              <div className="text-sm text-theme-text-secondary font-semibold">
                {stringFormatingToPascal(item?.document?.typeOfDocument)}
              </div>
              <button
                className="ui-btn-hyperlink ui-link-icon text-xs font-bold"
                onClick={() => {
                  if (item?.document?.name) {
                    setIsLoading(true);
                    dispatch(
                      getImage({
                        imageFileName: item?.document?.name ?? "",
                        policyId: item?.policy?.contractID,
                      })
                    )
                      .then((response) => {
                        setIsLoading(false);
                        let byteArray = base64ToArrayBuffer(
                          response.payload.document.contentStream.type
                        );
                        let blob = new Blob([byteArray], {
                          type: "application/pdf",
                        });
                        fileSaver.saveAs(blob, `${item?.document?.name}.pdf`);
                      })
                      .catch((error) => {
                        setIsLoading(false);
                        console.log("Error", error.message);
                        setName(item?.document?.name);
                        setPdfDialogState(true);
                        setDesc(item?.document?.description);
                        setPdfSource("");
                      });
                  }
                }}
              >
                <svg
                  className="ui-icon w-4 h-4"
                  focusable="false"
                  aria-hidden="true"
                  role="presentation"
                >
                  <use href="#ui-icon-document-download"></use>
                </svg>
                <span>{t("AgentReportCard-downloadPDFText")} </span>{" "}
                <span className="sr-only"> {item.srTitle}</span>
              </button>
            </div>
          </div>
        ))}
      </LoadingOverlay>
      <PDFDialog
        title={`${name ?? ""} Preview`}
        description={desc}
        pdfSource={pdfSource}
        dialogState={pdfDialogState}
        setDialogState={setPdfDialogState}
      />
    </>
  );
};

export default ReportCard;
